import { Fragment, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import {
  ResultContainer,
  Icon,
  Tooltip,
  ListItem,
  ListItemText,
  Typography,
} from './styles';

import IntegrationError from '~/shared/components/Dialogs/IntegrationError';

const CustomRowHeadCells = ({ data, headCells }) => {
  const [showDialog, setShowDialog] = useState(false);

  const headCellsExclude = [];
  headCells.forEach(headCell => {
    if (headCell.exclude) headCellsExclude.push(headCell.id);
  });

  const headCellsFinded = headCells.filter(
    headCell =>
      !headCellsExclude.some(headCellExclude =>
        headCellExclude.includes(headCell.id)
      )
  );

  return (
    <Fragment key={data.id}>
      <IntegrationError open={showDialog} setOpen={setShowDialog} data={data} />
      {headCellsExclude.map(headCellExclude => (
        <TableCell key={headCellExclude}>
          {data[`${headCellExclude}_icon`] === 'error' ? (
            <ResultContainer>
              <Tooltip
                title={data[`${headCellExclude}_status`] || 'Erro'}
                arrow
                onClick={() => setShowDialog(true)}
                placement="right"
              >
                <Icon status={data[`${headCellExclude}_icon`]}>
                  {data[`${headCellExclude}_icon`]}
                </Icon>
              </Tooltip>

              <ListItem>
                <ListItemText
                  primary={
                    <Typography>{data[`${headCellExclude}_status`]}</Typography>
                  }
                  secondary={
                    <Tooltip arrow placement="top-start" title="Atualizado em">
                      <div>{data[`${headCellExclude}_updated_at`]}</div>
                    </Tooltip>
                  }
                />
              </ListItem>
            </ResultContainer>
          ) : (
            <ResultContainer>
              <Icon status={data[`${headCellExclude}_icon`]}>
                {data[`${headCellExclude}_icon`]}
              </Icon>
              {data[`${headCellExclude}_icon`] === 'refresh' &&
                data[`${headCellExclude}_status`]}
              <ListItem>
                {data[`${headCellExclude}_icon`] !== 'done' ? (
                  <ListItemText
                    primary={
                      <Typography>
                        {data[`${headCellExclude}`] ||
                          data[`${headCellExclude})_status`]}
                      </Typography>
                    }
                    secondary={
                      <Tooltip
                        arrow
                        placement="top-start"
                        title="Atualizado em"
                      >
                        <div>{data[`${headCellExclude}_updated_At`]}</div>
                      </Tooltip>
                    }
                  />
                ) : (
                  <ListItemText
                    primary={
                      <Typography>
                        {data[`${headCellExclude}`] ||
                          data[`${headCellExclude}_status`]}
                      </Typography>
                    }
                    secondary={
                      <Tooltip
                        arrow
                        placement="top-start"
                        title="Atualizado em"
                      >
                        <div>{data[`${headCellExclude}_updated_at`]}</div>
                      </Tooltip>
                    }
                  />
                )}
              </ListItem>
            </ResultContainer>
          )}
        </TableCell>
      ))}
      {headCellsFinded.map(headCellFinded => (
        <TableCell key={headCellFinded.id}>{data[headCellFinded.id]}</TableCell>
      ))}
    </Fragment>
  );
};

export default CustomRowHeadCells;

CustomRowHeadCells.propTypes = {
  data: PropTypes.shape().isRequired,
  headCells: PropTypes.arrayOf().isRequired,
};
